module.exports = __webpack_public_path__ + "f9f4bc69abc5caa473bd14dcab71e8fa.pdf";